module.exports = __webpack_public_path__ + "static/media/user.cb0aaf5e.png";